<template>
  <v-btn
    :class="{'cell-opened': !enabled, 'cell-selected': selected}"
    :width="btn.width"
    :height="btn.height"
    @click="$emit('open', lockerId)"
    :disabled="!enabled || isLockerOpened"
  >
    <v-img
      :src="getImgUrl(size)"
    ></v-img>
  </v-btn>
</template>
<script>
export default {
  props: {
    btn: Object,
    lockerId: Number,
    cellNo: String,
    size: String,
  },
  data() {
    return {
      url: {
        small: "locker-s.png",
        medium: "locker-m.png",
        large: "locker-l.png"
      },
      lock: {
        color: "white",
        url: "icon-key1.png",
      },
      unlock: {
        color: "#00E676",
        url: "icon-key2.png",
      },
      enabled: true,
      selected: false,
      isLockerOpened: false,
    };
  },
  methods: {
    getImgUrl(size) {
      let sizeUrl = "";
      switch (size) {
        case "S":
          sizeUrl = this.url.small;
          break;
        case "M":
          sizeUrl = this.url.medium;
          break;
        case "L":
          sizeUrl = this.url.large;
          break;
      }
      return require("../../assets/images/icons/" + sizeUrl);
    },
  },
  mounted() {
    this.$root.$on("open cell", (no) => {
      if (this.cellNo == no) {
        this.enabled = false;
      }
      this.isLockerOpened = true;
    });
    this.$root.$on("select", (no) => {
      if (this.cellNo == no) {
        this.selected = true;
      }
    });
    this.$root.$on("unselect", (no) => {
      if (this.cellNo != no) {
        this.selected = false;
      }
    });
    this.$root.$on("unselectAll", () => {
      this.selected = false;
      this.enabled = true;
      this.isLockerOpened = false;
    });
  },
};
</script>
<style scoped>
.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).cell-opened,.cell-selected {
  background-color: rgb(0, 230, 118) !important;
  border-color: rgb(0, 230, 118) !important;
}
</style>